export enum MaterialDropdownState {
  ALL,
  DETACHED,
}

export enum MaterialAnnotationType {
  HIGHLIGHTS = 'highlights',
  NOTES = 'notes',
  PLACEMARKS = 'placemarks',
}

export enum BatchDeleteState {
  IDLE,
  PENDING,
  SUCCESS,
  CANCELED,
}

export interface EditModeSelectionState {
  someSelected: boolean
  allSelected: boolean
};
